/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';
export default function IconDatasourceConfluenceSearch() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12H44V22H18V12Z",
    fill: "white",
    stroke: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8H43C43.5523 8 44 8.44772 44 9V12H18V8Z",
    fill: "#DCDFE4",
    stroke: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22H44V31C44 31.5523 43.5523 32 43 32H18V22Z",
    fill: "white",
    stroke: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12H19V22H7V12Z",
    fill: "white",
    stroke: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9C7 8.44772 7.44772 8 8 8H19V12H7V9Z",
    fill: "#DCDFE4",
    stroke: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 22H19V32H8C7.44772 32 7 31.5523 7 31V22Z",
    fill: "white",
    stroke: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "16",
    width: "19",
    height: "2",
    rx: "1",
    fill: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "26",
    width: "19",
    height: "2",
    rx: "1",
    fill: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 14C15.6642 14 16 14.3358 16 14.75V19.25C16 19.6642 15.6642 20 15.25 20H10.75C10.3358 20 10 19.6642 10 19.25V14.75C10 14.3358 10.3358 14 10.75 14H15.25ZM13 18.2188H11.3125L11.2743 18.2213C11.1371 18.2399 11.0312 18.3576 11.0312 18.5C11.0312 18.6424 11.1371 18.7601 11.2743 18.7787L11.3125 18.7812H13L13.0382 18.7787C13.1754 18.7601 13.2812 18.6424 13.2812 18.5C13.2812 18.3576 13.1754 18.2399 13.0382 18.2213L13 18.2188ZM14.6875 16.7188H11.3125L11.2743 16.7213C11.1371 16.7399 11.0312 16.8576 11.0312 17C11.0312 17.1424 11.1371 17.2601 11.2743 17.2787L11.3125 17.2812H14.6875L14.7257 17.2787C14.8629 17.2601 14.9688 17.1424 14.9688 17C14.9688 16.8576 14.8629 16.7399 14.7257 16.7213L14.6875 16.7188ZM14.6875 15.2188H11.3125L11.2743 15.2213C11.1371 15.2399 11.0312 15.3576 11.0312 15.5C11.0312 15.6424 11.1371 15.7601 11.2743 15.7787L11.3125 15.7812H14.6875L14.7257 15.7787C14.8629 15.7601 14.9688 15.6424 14.9688 15.5C14.9688 15.3576 14.8629 15.2399 14.7257 15.2213L14.6875 15.2188Z",
    fill: "#1D7AFC"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 24C10.3358 24 10 24.3358 10 24.75V29.25C10 29.6642 10.3358 30 10.75 30H15.25C15.6642 30 16 29.6642 16 29.25V24.75C16 24.3358 15.6642 24 15.25 24H10.75ZM12.5592 25.2762C12.9705 24.7901 13.5639 24.6203 13.984 24.8503C14.0404 24.8812 14.1215 24.931 14.1833 25.0108C14.2537 25.1019 14.2886 25.2185 14.2662 25.3497C14.2462 25.4673 14.1833 25.5783 14.1006 25.6839C14.0507 25.7476 13.9887 25.8155 13.9137 25.8884C14.3262 25.7411 14.685 25.7436 14.9427 25.9243C15.2387 26.1317 15.2938 26.4949 15.2201 26.8074C15.1884 26.9418 15.0538 27.025 14.9194 26.9933C14.785 26.9616 14.7018 26.827 14.7335 26.6926C14.7799 26.4959 14.7237 26.3813 14.6558 26.3337C14.5801 26.2807 14.3781 26.2279 13.9626 26.4063C13.8762 26.4434 13.7735 26.4474 13.6983 26.4429C13.617 26.4381 13.5166 26.4201 13.4274 26.3761C13.3436 26.3348 13.2046 26.2336 13.2035 26.0449C13.2025 25.8806 13.312 25.755 13.4117 25.6693C13.5572 25.5443 13.6502 25.4482 13.707 25.3757C13.7328 25.3426 13.7493 25.3169 13.7596 25.2978C13.755 25.2951 13.7498 25.2921 13.7439 25.2889C13.6023 25.2113 13.2571 25.2255 12.9408 25.5992C12.8517 25.7046 12.6939 25.7178 12.5885 25.6286C12.4831 25.5394 12.47 25.3816 12.5592 25.2762ZM11.8125 27.5625C12.1232 27.5625 12.375 27.3107 12.375 27C12.375 26.6894 12.1232 26.4375 11.8125 26.4375C11.5018 26.4375 11.25 26.6894 11.25 27C11.25 27.3107 11.5018 27.5625 11.8125 27.5625ZM11.8125 28.0625C12.3993 28.0625 12.875 27.5868 12.875 27C12.875 26.4132 12.3993 25.9375 11.8125 25.9375C11.2257 25.9375 10.75 26.4132 10.75 27C10.75 27.5868 11.2257 28.0625 11.8125 28.0625ZM13.1331 28.75L13.75 27.7218L14.3669 28.75H13.1331ZM14.0716 27.2859L14.9092 28.6821C15.0592 28.932 14.8792 29.25 14.5877 29.25L12.9123 29.25C12.6208 29.25 12.4408 28.932 12.5908 28.6821L13.4284 27.2859C13.5741 27.0432 13.9259 27.0432 14.0716 27.2859Z",
    fill: "#2898BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "39",
    height: "39",
    rx: "2.5",
    stroke: "#DFE1E6"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "6",
    height: "6",
    fill: "white",
    transform: "translate(10 14)"
  }))));
}